<template>
  <CartNotification>
    <template #header>
      <CartNotificationHeader :text="text" />
    </template>
    <template #content>
      <VRow class="ma-0">
        <VCol class="pt-5 pb-0">
          <p>
            {{ message }}
          </p>
        </VCol>
      </VRow>
    </template>
  </CartNotification>
</template>

<script setup lang="ts">
import CartNotification from '~/components/notification/cart/base/CartNotification.vue'
import CartNotificationHeader from '~/components/notification/cart/common/CartNotificationHeader.vue'

interface Props {
  title?: string
  message?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  message: ''
})

const $i18n = useI18n()

const text = computed(() => $i18n.ts(props.title))
</script>

<style lang="scss">

</style>
